import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ words, speed = 20 }) {
  const items = Array.isArray(words) ? words : String(words).split(" . ");
  return (
    <div className="py-8 md:py-14 border-y border-neutral-300 bg-[#F7F7F6] overflow-hidden">
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        <span className="marquee-item">
          {items.map((w, i) => (
            <span key={i} className="marquee-item">
              <span>{w}</span>
              <span className="dot" />
            </span>
          ))}
        </span>
      </Marquee>
    </div>
  );
}
